import moment from "moment";
import { AvisConstants } from "../data/avisConstants";
import {
  LicenseNameAndAddress,
  PortalReportStatusTypeInfo,
  ProgramReportInfo,
  ProgramReportListInfo,
} from "../generated/data-contracts";
import { IUrlParamsLicensees } from "../models";
import { AvisUtils } from "./";

export class LicenseesUrls {
  static readonly licenseeLicenses = `/${AvisConstants.url_part_portal_licensees}/licenses`;
  static readonly licenseeLicenseView = `${LicenseesUrls.licenseeLicenses}/view/${AvisConstants.url_id_param}`;
  static readonly licenseeLicenseViewInvoices = `${LicenseesUrls.licenseeLicenseView}/invoices`;
  static readonly licenseeLicenseViewChildLicenses = `${LicenseesUrls.licenseeLicenseView}/child-licenses`;
  static readonly licenseeLicenseViewReport = `${LicenseesUrls.licenseeLicenseView}/report/${AvisConstants.url_report_form_type_param}/${AvisConstants.url_invoice_plan_id_param}`;
  static readonly licenseeLicenseViewReportPP = `${LicenseesUrls.licenseeLicenseViewReport}/pp/${AvisConstants.url_client_event_id_param}`;

  static readonly licenseeReports = `/${AvisConstants.url_part_portal_licensees}/reports`;
  static readonly licenseeInvoices = `/${AvisConstants.url_part_portal_licensees}/invoices`;
}
export class LicenseesUtils {
  static getUrlWithParams(
    path: string | undefined,
    urlParams?: IUrlParamsLicensees,
    addFilterTag?: boolean,
  ): string {
    let result = path ?? AvisUtils.getStartPagePath();

    if (addFilterTag && result.indexOf(AvisConstants.url_hash_filter) == -1)
      result += AvisConstants.url_hash_filter;

    //return if params not provided
    if (!urlParams) return result;

    if (urlParams.licenseId) {
      result = result.replace(
        AvisConstants.url_id_param,
        btoa(urlParams.licenseId.toString()),
      );
    }
    if (urlParams.licenseReportFormType) {
      result = result.replace(
        AvisConstants.url_report_form_type_param,
        urlParams.licenseReportFormType.toString(),
      );
    }
    if (urlParams.licenseInvoicePlanId) {
      result = result.replace(
        AvisConstants.url_invoice_plan_id_param,
        btoa(urlParams.licenseInvoicePlanId.toString()),
      );
    }
    if (urlParams.licenseClientEventId) {
      result = result.replace(
        AvisConstants.url_client_event_id_param,
        btoa(urlParams.licenseClientEventId.toString()),
      );
    }
    if (urlParams.isCopy) {
      result += result.indexOf("?") > -1 ? "&" : "?";
      result += `${AvisConstants.licenses_reports_pp_copy_param}=1`;
    }

    return result;
  }

  static getUrlParams(): IUrlParamsLicensees {
    const urlParams: IUrlParamsLicensees = {};
    const pathname = location.pathname.slice(1);
    const pathUrlPart = pathname.split("?")[0];
    const pathParts = pathUrlPart.split("/");

    if (pathParts.length < 2) return urlParams;

    if (pathParts.length >= 4)
      urlParams.licenseId = parseInt(
        AvisUtils.atobParam("licenseId", pathParts[3]),
      );

    if (pathParts.length >= 6)
      urlParams.licenseReportFormType = parseInt(pathParts[5]);
    if (pathParts.length >= 7)
      urlParams.licenseInvoicePlanId = parseInt(
        AvisUtils.atobParam("licenseInvoicePlanId", pathParts[6]),
      );
    if (pathParts.length >= 9)
      urlParams.licenseClientEventId = parseInt(
        AvisUtils.atobParam("licenseClientEventId", pathParts[8]),
      );
    return urlParams;
  }
  static getLicenseObjectValue(objectData: LicenseNameAndAddress) {
    let data: string[] = [objectData.name ?? "", objectData.address ?? ""];
    data = data.filter((x) => x);
    return data.join(", ");
  }

  static readonly formatProgramReportInfo = (
    item: ProgramReportListInfo | ProgramReportInfo,
  ) => {
    const programReportInfoParts = [
      moment(item.eventDate).format(AvisConstants.date_format),
      item.eventName,
      `Licence ${item.licenseNumber}`,
    ];

    return programReportInfoParts.join(", ");
  };

  static readonly hasNoPortalReport = (
    reportStatus: PortalReportStatusTypeInfo | undefined,
    eventNotOccured: boolean | undefined,
    rowCount: number | undefined,
  ) => {
    if (eventNotOccured) return false;

    if (!reportStatus) return false;

    const isReadOnlyStatus =
      reportStatus.value != "NotSubmitted" && reportStatus.value != "Rejected";

    return isReadOnlyStatus && rowCount == 0;
  };
}
